var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showRackEditButton)?_c('div',[_c('CallToAction',{attrs:{"text":_vm.$dictionary.get('RackConfigurator.ProductDetails.Button'),"icon":"edit"},on:{"click":_vm.handleClickOnRackEdit}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }